import React, { FunctionComponent } from "react";
import { Grid, makeStyles, Theme, useMediaQuery, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { NutrientIndicatorExplanationHero } from "./nutrient-indicator-explanation-hero";
import { MenuItemCategory } from "../../../../models/types/category-types";
import { HeadingText } from "../../../../components/text/heading-text";
import { ContentText } from "../../../../components/text/content-text";
import { NutrientIndicatorExplanationHeroMobile } from "./nutrient-indicator-explanation-hero-mobile";

const useStyles = makeStyles((theme: Theme) => ({
  textContainer: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  hero: {
    width: "100%",
    height: "100%",
  },
  mobileHero: {
    marginTop: theme.spacing(4),
    width: "100%",
    maxWidth: "380px",
    transform: "scale(1.1) translateX(-3%)",
    height: "100%",
  },
}));

interface INutrientIndicatorExplanationProps {}

export const NutrientIndicatorExplanation: FunctionComponent<INutrientIndicatorExplanationProps> = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));
  return (
    <Grid container>
      <Grid item container direction="row">
        <HeadingText>{t(`menu_item_category.${[MenuItemCategory.MICRONUTRIENTS]}`)}</HeadingText>
      </Grid>
      <Grid item container direction="row" className={classes.textContainer}>
        <ContentText light>{t("micronutrient.explanation.heading")}:</ContentText>
      </Grid>
      <Grid
        item
        container
        direction="row"
        justify="center"
        style={{ paddingTop: theme.spacing(4), overflowX: "visible" }}
      >
        {isSm && <NutrientIndicatorExplanationHero className={classes.hero} />}
        {!isSm && <NutrientIndicatorExplanationHeroMobile className={classes.mobileHero} />}
      </Grid>
    </Grid>
  );
};
